import Marionette from 'backbone.marionette';
import { PriceRevealView } from '../../views';

import { redirectTo } from '../../utils';

export default class PriceRevealController extends Marionette.Object {

	redirectToPricePage() {
		redirectTo('2018-price-reveal');
	}

	/**
	 * Method for 2018-price-reveal
	 */
	priceReveal() {
		this.getOption('rootView')
			.getRegion('main')
			.show(new PriceRevealView());
	}
}